import { Environments } from '@monorepo/client-types';

/**
 * Environment Mapping Utilities
 * Converts environment strings to proper Environments enum values
 */

/**
 * Maps environment string to Environments enum
 * Provides explicit handling for all common environment values
 *
 * @param envString - Environment string (e.g., 'production', 'staging', 'development')
 * @returns Environments enum value
 *
 * @example
 * mapEnvironmentString('production') // => Environments.Production
 * mapEnvironmentString('staging') // => Environments.Development
 * mapEnvironmentString('dev') // => Environments.Development
 */
export const mapEnvironmentString = (envString?: string): Environments => {
  if (!envString) {
    return Environments.Development;
  }

  const normalizedEnv = envString.toLowerCase().trim();

  switch (normalizedEnv) {
    case 'production':
    case 'prod':
      return Environments.Production;

    case 'staging':
    case 'stage':
    case 'development':
    case 'dev':
    case 'local':
    default:
      return Environments.Development;
  }
};

/**
 * Checks if environment string represents production
 *
 * @param envString - Environment string
 * @returns true if production environment
 */
export const isProductionEnvironment = (envString?: string): boolean => {
  return mapEnvironmentString(envString) === Environments.Production;
};
